import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ModalFullscreen } from '@cian/ui-kit';

import { loadAnswers } from '../../actions/answers/loadAnswers';
import { ReviewPopupMobile } from '../../components/ReviewPopupMobile';
import { getReviewById } from '../../selectors/reviews';
import { AnswerListContainer } from '../AnswerList';
import { ReviewsItemContainer } from '../ReviewsItem';

export interface IReviewPopupContainerProps {
  reviewId: string;
  onClose(): void;
}

export const ReviewPopupContainer: React.FC<IReviewPopupContainerProps> = props => {
  const { reviewId, onClose } = props;

  const dispatch = useDispatch();
  const { answersCount } = useSelector(getReviewById(reviewId));

  React.useEffect(() => {
    dispatch(
      loadAnswers({
        reviewId,
        page: 0,
      }),
    );
  }, [reviewId, dispatch]);

  return (
    <ModalFullscreen open onClose={onClose} theme="white">
      <ReviewPopupMobile
        title="Отзыв"
        close={onClose}
        review={<ReviewsItemContainer id={reviewId} inPopup />}
        answersCount={answersCount}
        answers={<AnswerListContainer reviewId={reviewId} inPopup />}
      />
    </ModalFullscreen>
  );
};
